"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextInputWrapper = exports.Input = exports.IconButton = void 0;
var _uiKit = require("@icis/ui-kit");
var _styledComponents = _interopRequireDefault(require("styled-components"));
const {
  colours,
  fonts
} = _uiKit.theme;
const TextInputWrapper = exports.TextInputWrapper = _styledComponents.default.div.withConfig({
  displayName: "TextInputstyle__TextInputWrapper",
  componentId: "sc-1oz4myn-0"
})(["position:relative;width:100%;box-sizing:border-box !important;margin-right:5px;button{max-width:initial;width:initial;}"]);
const Input = exports.Input = _styledComponents.default.input.withConfig({
  displayName: "TextInputstyle__Input",
  componentId: "sc-1oz4myn-1"
})(["background:", " !important;border:none;outline:none;height:28px !important;width:100% !important;border-radius:4px !important;color:#001e3f !important;font-size:12px !important;padding:6px 28px 6px 12px !important;font-weight:", " !important;box-sizing:border-box !important;margin:0 !important;&::placeholder{font-weight:", ";font-style:italic;}", ";", " ", ";"], colours.NEUTRALS_5, fonts.weight.SEMI_BOLD, fonts.weight.REGULAR, props => props.isError && "\n    border: 1px solid ".concat(colours.ERROR, ";\n  "), props => {
  if (props.disabled) {
    return '';
  }
  if (!props.isValid) return "\n          color: ".concat(colours.NEUTRALS_9, "\n      ");
}, props => props.tallerInput && "\n    height: 35px;\n  ");
const IconButton = exports.IconButton = _styledComponents.default.button.withConfig({
  displayName: "TextInputstyle__IconButton",
  componentId: "sc-1oz4myn-2"
})(["position:absolute;right:6px;top:0;background:transparent;cursor:pointer;height:100%;padding:0 8px;border:0 !important;width:initial !important;&[disabled]{cursor:default;}", ";svg{height:14px;g{fill:", ";}}"], props => props.tallerInput && "\n    padding: 0 8px;\n  ", colours.PRIMARY_1);